
export default (id) => {
    const popupContainer = document.querySelector(id)
    if(!popupContainer) return;
   
    const popupClose = popupContainer.querySelector('.close-button')
    const popupBackground = popupContainer.querySelector('.background-overlay')

    if (id === '#demographics') {
        const setCookie = (name, value, days) => {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires + "; path=/";
        }

        const getCookie = (name) => {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        }

        const eraseCookie = (name) => {   
            document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
        }

        const checkDemoPopup = () => {
            if( getCookie('ZC_demo_box') != 'YES' ) {
                setCookie('ZC_demo_box', 'YES', 1)
                openPopUp()
            } else {
                console.log('Ignore Pop')
            }
        }

        document.addEventListener('DOMContentLoaded', (e) => {
            checkDemoPopup();
        }, false)

    } else {
        openPopUp()
    }
        
    const openPopUp = () => {
        popupContainer.classList.add('visible')
    }

    const closePopUp = () => {
        popupContainer.classList.remove('visible')
    }

    
    popupBackground.addEventListener('click', closePopUp)
    popupClose.addEventListener('click', closePopUp)  

}

